<template>
  <div class="international-footer-section theme-background">
    <div>
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
        class="flex-wrap">
        <div>
          <router-link
            to="/international"
          >
            <img
              class="logo"
              src="../assets/images/logo-new.svg">
          </router-link>
        </div>
        <div>
          <el-row
            type="flex"
            justify="space-between"
            class="flex-wrap">
            <div>
              <div class="secondary-menu">
                <router-link
                  to="/terms"
                  aria-label="Terms of service"
                  @click.native="scrollToTop('terms')"
                >
                  Terms of Service
                </router-link>
                <router-link
                  to="/privacy"
                  aria-label="Policy"
                  @click.native="scrollToTop('privacy')"
                >
                  Policy
                </router-link>
                <router-link
                  to="/international"
                  class="hidden-xs-only">&copy; {{ new Date().getFullYear() }} Luminary Media, LLC
                </router-link>
              </div>
              <div class="mobile-menu-last-item t-c hidden-sm-and-up">
                <router-link to="/international">&copy; {{ new Date().getFullYear() }} Luminary Media, LLC</router-link>
              </div>
            </div>
            <div class="social">
              <div class="social-share-icons">
                <a
                  href="https://www.facebook.com/hearluminary/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 22 22"><defs><path id="share_facebook_gray_svg__a" d="M20.7854167,0 L1.21458333,0 C0.543583333,0 0,0.543583333 0,1.21458333 L0,20.7863333 C0,21.4564167 0.543583333,22 1.21458333,22 L11.7516667,22 L11.7516667,13.4805 L8.88433333,13.4805 L8.88433333,10.1603333 L11.7516667,10.1603333 L11.7516667,7.71191667 C11.7516667,4.87025 13.4869167,3.32291667 16.0224167,3.32291667 C17.237,3.32291667 18.2801667,3.41366667 18.5845,3.454 L18.5845,6.424 L16.8263333,6.42491667 C15.4476667,6.42491667 15.1809167,7.08033333 15.1809167,8.041 L15.1809167,10.16125 L18.469,10.16125 L18.0409167,13.4814167 L15.1809167,13.4814167 L15.1809167,22 L20.78725,22 C21.4564167,22 22,21.4564167 22,20.7854167 L22,1.21458333 C22,0.543583333 21.4564167,-6.10622664e-16 20.7854167,0 Z"/></defs><g fill="none" fill-rule="evenodd"><g><mask id="share_facebook_gray_svg__b" fill="white"><use xlink:href="#share_facebook_gray_svg__a"/></mask><rect width="24" height="24" x="-1" y="-1" fill="#CCCCCC" mask="url(#share_facebook_gray_svg__b)"/></g></g></svg>
                </a>
                <a
                  href="https://twitter.com/hearluminary"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="share_twitter_gray_svg__a" d="M10.6822554,4.78828184 L10.729944,5.5668326 L9.93513333,5.47149985 C7.04202251,5.10605766 4.51452459,3.86673196 2.36853579,1.78530033 L1.31938571,0.752528913 L1.04915008,1.51519088 C0.4768864,3.21529152 0.842499307,5.01072491 2.03471531,6.21827303 C2.67056384,6.88560225 2.52749792,6.980935 1.4306592,6.58371522 C1.04915008,6.4566049 0.7153296,6.36127215 0.683537173,6.40893852 C0.57226368,6.52016006 0.9537728,7.96604004 1.25580085,8.53803652 C1.6691024,9.33247607 2.51160171,10.1110268 3.43358208,10.5718018 L4.21249653,10.937244 L3.29051616,10.9531328 C2.40032821,10.9531328 2.36853579,10.9690216 2.46391307,11.3026862 C2.78183733,12.3354576 4.03763819,13.4317842 5.43650496,13.9084479 L6.42207019,14.2421125 L5.56367467,14.7505538 C4.2919776,15.4814382 2.79773355,15.8945468 1.30348949,15.9263244 C0.588159893,15.9422131 -2.15301838e-14,16.0057683 -2.15301838e-14,16.0534347 C-2.15301838e-14,16.2123226 1.93933803,17.1020949 3.06796917,17.4516483 C6.45386261,18.4844197 10.4756046,18.0395336 13.4958851,16.2758778 C15.6418739,15.0206633 17.7878627,12.5261231 18.7893242,10.1110268 C19.3297954,8.82403476 19.8702667,6.47249369 19.8702667,5.34438952 C19.8702667,4.61350514 19.9179553,4.51817239 20.8081432,3.64428888 C21.3327183,3.13584757 21.8255009,2.57973988 21.9208782,2.42085197 C22.0798403,2.11896494 22.0639441,2.11896494 21.2532372,2.38907439 C19.9020591,2.86573812 19.7113045,2.80218296 20.3789455,2.08718736 C20.8717281,1.57874605 21.459888,0.657196167 21.459888,0.387086719 C21.459888,0.339420346 21.2214448,0.418864301 20.9512092,0.561863421 C20.6650773,0.720751331 20.0292288,0.959083197 19.5523424,1.10208232 L18.6939469,1.37219176 L17.9150324,0.847861659 C17.4858347,0.561863421 16.8817786,0.2440876 16.5638543,0.148754854 C15.7531474,-0.0736882209 14.5132428,-0.0419106388 13.782017,0.212310018 C11.7949903,0.927305615 10.5391894,2.77040538 10.6822554,4.78828184 Z"/><rect id="share_twitter_gray_svg__c" width="24" height="24" x="0" y="0"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-93.000000, -752.000000) translate(93.000000, 752.000000) translate(1.000000, 3.000000)"><mask id="share_twitter_gray_svg__b" fill="white"><use xlink:href="#share_twitter_gray_svg__a"/></mask><g mask="url(#share_twitter_gray_svg__b)"><g><g transform="translate(-1.000000, -3.000000)"><mask id="share_twitter_gray_svg__d" fill="white"><use xlink:href="#share_twitter_gray_svg__c"/></mask><g fill="#CCCCCC" mask="url(#share_twitter_gray_svg__d)"><rect width="24" height="24"/></g></g></g></g></g></g></g></g></svg>
                </a>
                <a
                  href="https://instagram.com/hearluminary"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 22 22"><defs><path id="share_instagram_gray_svg__a" d="M11.0000218,0 C13.9874206,0 14.362019,0.0126627249 15.5352859,0.0661954863 C16.7061077,0.119597254 17.5057369,0.305564652 18.205418,0.577507587 C18.9287652,0.858576416 19.5422088,1.23470301 20.1537747,1.8462253 C20.765297,2.45779125 21.1414236,3.07123477 21.4225361,3.79458202 C21.6944353,4.49426307 21.8804027,5.29389232 21.9338045,6.46471407 C21.9873373,7.63798103 22,8.01257937 22,11.0000218 C22,13.9874206 21.9873373,14.362019 21.9338045,15.5352859 C21.8804027,16.7061077 21.6944353,17.5057369 21.4225361,18.205418 C21.1414236,18.9287652 20.765297,19.5422088 20.1537747,20.1537747 C19.5422088,20.765297 18.9287652,21.1414236 18.205418,21.4225361 C17.5057369,21.6944353 16.7061077,21.8804027 15.5352859,21.9338045 C14.362019,21.9873373 13.9874206,22 11.0000218,22 C8.01257937,22 7.63798103,21.9873373 6.46471407,21.9338045 C5.29389232,21.8804027 4.49426307,21.6944353 3.79458202,21.4225361 C3.07123477,21.1414236 2.45779125,20.765297 1.8462253,20.1537747 C1.23470301,19.5422088 0.858576416,18.9287652 0.577507587,18.205418 C0.305564652,17.5057369 0.119597254,16.7061077 0.0661954863,15.5352859 C0.0126627249,14.362019 0,13.9874206 0,11.0000218 C0,8.01257937 0.0126627249,7.63798103 0.0661954863,6.46471407 C0.119597254,5.29389232 0.305564652,4.49426307 0.577507587,3.79458202 C0.858576416,3.07123477 1.23470301,2.45779125 1.8462253,1.8462253 C2.45779125,1.23470301 3.07123477,0.858576416 3.79458202,0.577507587 C4.49426307,0.305564652 5.29389232,0.119597254 6.46471407,0.0661954863 C7.63798103,0.0126627249 8.01257937,0 11.0000218,0 Z M11.0000218,2 C8.06875047,2 7.72152646,2.01119937 6.56393881,2.06401507 C5.49359292,2.11282166 4.91231519,2.29166293 4.52547941,2.44200465 C4.01305383,2.64115296 3.64735304,2.87904149 3.26321906,3.26321906 C2.87904149,3.64735304 2.64115296,4.01305383 2.44200465,4.52547941 C2.29166293,4.91231519 2.11282166,5.49359292 2.06401507,6.56393881 C2.01119937,7.72152646 2,8.06875047 2,11.0000218 C2,13.9312495 2.01119937,14.2784735 2.06401507,15.4360612 C2.11282166,16.5064071 2.29166293,17.0876848 2.44200465,17.4745206 C2.64115296,17.9869462 2.87908507,18.352647 3.26321906,18.7367809 C3.64735304,19.1209585 4.01305383,19.358847 4.52547941,19.5579953 C4.91231519,19.7083371 5.49359292,19.8871783 6.56393881,19.9359849 C7.72139573,19.9888006 8.06853258,20 11.0000218,20 C13.9314674,20 14.2786478,19.9888006 15.4360612,19.9359849 C16.5064071,19.8871783 17.0876848,19.7083371 17.4745206,19.5579953 C17.9869462,19.358847 18.352647,19.1209585 18.7367809,18.7367809 C19.1209585,18.352647 19.358847,17.9869462 19.5579953,17.4745206 C19.7083371,17.0876848 19.8871783,16.5064071 19.9359849,15.4360612 C19.9888006,14.2784735 20,13.9312495 20,11.0000218 C20,8.06875047 19.9888006,7.72152646 19.9359849,6.56393881 C19.8871783,5.49359292 19.7083371,4.91231519 19.5579953,4.52547941 C19.358847,4.01305383 19.1209585,3.64735304 18.7367809,3.26321906 C18.352647,2.87904149 17.9869462,2.64115296 17.4745206,2.44200465 C17.0876848,2.29166293 16.5064071,2.11282166 15.4360612,2.06401507 C14.2784735,2.01119937 13.9312495,2 11.0000218,2 Z M11.0000213,14.9641777 C12.9717639,14.9641777 14.5701777,13.3657639 14.5701777,11.3940213 C14.5701777,9.42223611 12.9717639,7.82382232 11.0000213,7.82382232 C9.02823611,7.82382232 7.42982232,9.42223611 7.42982232,11.3940213 C7.42982232,13.3657639 9.02823611,14.9641777 11.0000213,14.9641777 Z M11.0000213,5.894 C14.0375857,5.894 16.5,8.35641434 16.5,11.3940213 C16.5,14.4315857 14.0375857,16.894 11.0000213,16.894 C7.96241434,16.894 5.5,14.4315857 5.5,11.3940213 C5.5,8.35641434 7.96241434,5.894 11.0000213,5.894 Z M18.5625,5.26902274 C18.5625,6.02842136 17.9468759,6.644 17.1874773,6.644 C16.4281241,6.644 15.8125,6.02842136 15.8125,5.26902274 C15.8125,4.50962412 16.4281241,3.894 17.1874773,3.894 C17.9468759,3.894 18.5625,4.50962412 18.5625,5.26902274 Z"/></defs><g fill="none" fill-rule="evenodd"><g><mask id="share_instagram_gray_svg__b" fill="white"><use xlink:href="#share_instagram_gray_svg__a"/></mask><rect width="24" height="24" x="-1" y="-1" fill="#CCCCCC" mask="url(#share_instagram_gray_svg__b)"/></g></g></svg>
                </a>
              </div>
            </div>
          </el-row>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentRoute() {
      return this.$route.path;
    },
  },
  methods: {
    scrollToTop(link) {
      if (link !== this.currentRoute) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables.scss";

.international-footer-section {
  width: 100%;
  // background: #111111;
  border-top: 1px solid $dark-border;
  & > div {
    padding: 46px 203px;
  }

  h1 {
    font-family: $clear-sans;
    color: #ffffff;
    margin: 0px;
  }

  img.logo {
    height: 43px;
    width: 178px;
    &:hover {
      opacity: .7;
    }
    @media (max-width: $lg - 1) {
      height: 36px;
      width: 149px;
    }
    @media (max-width: $md - 1) {
      height: 32px;
      width: 132px;
    }
    @media (max-width: $sm - 1) {
      height: 32px;
      width: 132px;
    }
  }

  .secondary-menu {
    font-size: 14px;
    letter-spacing: -0.17px;
    line-height: 32px;
    margin-right: 48px;

    a {
      color: #ffffff;
      position: relative;

      margin: 0 8px;

      &:not(:last-child) {
        &::after {
          content: '';

          position: absolute;
          top: 0;
          right: -8px;

          height: 100%;
          width: 1px;

          background-color: white;
        }
      }

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }

    a:last-child{
      color: #666;
      border-right: 0px;
    }
  }

  .social-share-icons {
    a {
      cursor: pointer;

      &:not(:last-child) {
        margin-right: 32px;
      }

      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
}

@media (max-width: 1200px) {
  .international-footer-section {
    > div {
      padding: 30px 80px;
    }
  }
}

@media (max-width: 1024px) {
  .international-footer-section {
    > div{
      padding: 30px 80px;
    }

    .logo{
      display: none;
    }

    .secondary-menu{
      font-size: 14px;
      letter-spacing: -0.17px;
      line-height: 32px;
      margin-right: 28px;
      a{
        color: #ffffff;
      }
      a:last-child{
        color: #666;
        border-right: 0px;
      }
    }
    .social-share-icons{
      a {
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 12px;
        }
        svg {
          width: 24px;
          height: 24px;
        }
      }
    }
    &> .el-row {
      flex-direction: column;
      &> div:first-child {
        margin: auto;
      }
      &> div:last-child {
        width: 100%;
      }
    }
  }
}

@media (max-width: 768px) {
  .international-footer-section{
    &> div{
      padding: 46px 36px;
    }

    h1 {
      font-family: $clear-sans;
      font-weight: bold;
      color: #ffffff;
      margin: 0px;
      margin-bottom: 16px;
    }

    .secondary-menu {
      font-size: 14px;
      letter-spacing: -0.17px;
      line-height: 32px;
      margin-right: 0px;

      a{
        color: #ffffff;

        &:nth-child(2) {
          &::after {
            content: none;
          }
        }
      }
      a:last-child{
        color: #666;
        border-right: 0px;
      }
    }
    .social {
      .social-share-icons{
        text-align: center;
        margin: auto;
        a {
          cursor: pointer;

          &:not(:last-child) {
            margin-right: 32px;
          }
          svg {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }
}

@media (max-width: 567px) {
  .international-footer-section{
    margin-bottom: 0px;
    &> div{
      padding: 24px 62px;
    }
    .logo{
      display: none;
    }

    .el-row {
      flex-direction: column;
    }

    .secondary-menu {
      font-size: 14px;
      letter-spacing: -0.17px;
      line-height: 32px;
      margin-right: 0px;

      a {
        color: #ffffff;
      }

      a:last-child {
        color: #666;
        border-right: 0px;
      }
    }
    .mobile-menu-last-item {
      margin-bottom: 8px;

      a {
      color: #666;
      font-size: 14px;
      letter-spacing: -0.17px;
      line-height: 32px;
      }
    }
    .social-share-icons {
      text-align: center;
      a {
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 32px;
        }
        svg {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
  .is-safari .international-footer-section {
    margin-bottom: 70px;
  }
}
</style>
